<template>
    <div>
        <v-flex xs12 sm12 d-block class="card-dados">
            <h3 class="card-dados__titulo mb-0">Protocolo de Envio de Proposta</h3>

            <div class="protocolo">
                <i class="far fa-check-circle" aria-hidden="true"/>
                <h2 class="protocolo__titulo">Proposta enviada com sucesso!</h2>

                <button v-if="resumoProposta.numeroProtocolo"
                        @click="tratarEventoCliqueDownloadProtocolo"
                        class="protocolo__botao az-action-link-icon">
                    <i class="fas fa-download mr-2" aria-hidden="true"/>
                    <span><strong>Protocolo:</strong> {{ resumoProposta.numeroProtocolo }}</span>
                </button>

                <az-call-to-action id="botaoCancelarEnvio"
                                   @click="exibirDialogoDeConfirmacao"
                                   slot="actions"
                                   css-class="protocolo__botao-secundario">
                    Cancelar Envio
                </az-call-to-action>
            </div>
        </v-flex>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="tratarEventoVoltar"/>
        </div>


        <protocolo-modal-cancelar :exibirModal="exibirModalCancelarProtocolo"
                                  :numeroProtocolo="resumoProposta.numeroProtocolo"
                                  @fechar="exibirModalCancelarProtocolo = false"
                                  @cancelarProtocolo="cancelarEnvioProposta"/>

        <modal-opcoes-download
                :exibirModal="mostrarOpcoesDownload"
                @selecionarOpcao="downloadProtocoloVirtualizado"
                @fechar="fecharOpcoesDownload"
        />

    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import ProtocoloModalCancelar from '@/views/pages/fornecedor/etapas-participacao/protocolo/ProtocoloModalCancelar'
import ModalOpcoesDownload from '../../../../components/ModalOpcoesDownload'

export default {
    name: 'Protocolo',
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            exibirModalCancelarProtocolo: false,
            mostrarOpcoesDownload: false
        }
    },
    components: {
        ModalOpcoesDownload,
        ProtocoloModalCancelar
    },
    computed: {
        ...mapState(['resumoProposta'])
    },
    async mounted() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarResumoProposta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarResumoProposta() {
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, infoObj)
        },
        async cancelarEnvioProposta() {
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                numeroProtocolo: this.resumoProposta.numeroProtocolo
            }
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.CANCELAR_ENVIO_DA_PROPOSTA_SEM_DISPUTA, infoObj)
            this.propostaId = resultado.propostaId
            this.mostrarNotificacaoSucesso('Sua proposta foi cancelada com sucesso.')
            this.tratarEventoVoltar()
        },
        async tratarEventoCliqueDownloadProtocolo() {
            if(this.resumoProposta.idProtocoloVirtualizado) {
                this.abrirOpcoesDownload()
            }else{
                this.baixarProtocoloPreview()
            }
        },
        async baixarProtocoloPreview(){
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLO_PREVIEW, infoObj)
        },
        async downloadProtocoloVirtualizado(opcaoDownload){
            const infoObj = {
                idVirtualizado: this.resumoProposta.idProtocoloVirtualizado,
                opcaoDownloadVirtualizacao: opcaoDownload
            }
            this.fecharOpcoesDownload()
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLOS, infoObj)
        },
        abrirOpcoesDownload(){
            this.mostrarOpcoesDownload = true
        },
        fecharOpcoesDownload(){
            this.mostrarOpcoesDownload = false
        },
        exibirDialogoDeConfirmacao() {
            this.exibirModalCancelarProtocolo = true
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        tratarEventoVoltar() {
            this.$router.push({
                name: 'PropostaDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        }
    }
}
</script>

<style scoped lang="stylus">
    .protocolo
        text-align center
        padding 50px 0

        .fa-check-circle
            font-size 60px

        .fa-check-circle, &__titulo
            color var(--v-primary-base) !important

        &__titulo
            text-transform uppercase
            margin-top 10px

        &__botao
            background-color #e4e4e4
            color #444 !important
            padding 5px 15px
            border-radius 2px
            display block
            width 300px
            margin 30px auto

        &__botao-secundario
            color #444 !important
            border 0

    @media (max-width 720px)
        .protocolo
            .fa-check-circle
                font-size 48px

            &__titulo
                font-size 16px

    @media (max-width 480px)
        .protocolo
            padding 50px

            &__botao
                width auto
</style>
